/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Polite_Antsy_Cow_BlessInputs */

const fr_polite_antsy_cow_bless = /** @type {(inputs: Polite_Antsy_Cow_BlessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacts récents`)
};

/**

* @param {Polite_Antsy_Cow_BlessInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const polite_antsy_cow_bless = /** @type {((inputs?: Polite_Antsy_Cow_BlessInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Polite_Antsy_Cow_BlessInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_polite_antsy_cow_bless(inputs)
});